// Editors' read-only progress: per brand and frame day, the cases and each Sentinel's submitted and in-progress answers.

import { useAtomValue } from 'jotai';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { GoldenAdapter } from '@/adapters/golden.adapter';
import { getApiErrorMessage } from '@/lib/utils';
import { benchmarkProgressQueryAtom } from './benchmark-state';

export function BenchmarkProgress() {
  const progress = useAtomValue(benchmarkProgressQueryAtom);
  if (progress.isError) {
    return (
      <p role="alert" className="text-[13px] text-red-600">
        {getApiErrorMessage(progress.error, 'Could not load the progress.')}
      </p>
    );
  }
  if (progress.isPending) return <Skeleton className="h-40 w-full rounded-lg" />;
  if (progress.data.length === 0) return <p className="py-10 text-center text-[13px] text-gray-800">No cases yet.</p>;
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Brand</TableHead>
          <TableHead>Frame day</TableHead>
          <TableHead>Cases</TableHead>
          <TableHead>Sentinel</TableHead>
          <TableHead>Submitted</TableHead>
          <TableHead>In progress</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {progress.data.flatMap((row) => {
          const reviewers = row.reviewers.length ? row.reviewers : [null];
          return reviewers.map((reviewer, index) => (
            <TableRow key={`${row.accountId}-${row.frameDay}-${reviewer?.reviewer ?? 'none'}`}>
              <TableCell>{index === 0 ? GoldenAdapter.brandName(row.accountId) : ''}</TableCell>
              <TableCell className="tabular-nums">{index === 0 ? row.frameDay : ''}</TableCell>
              <TableCell className="tabular-nums">{index === 0 ? row.cases : ''}</TableCell>
              <TableCell>{reviewer?.reviewer ?? 'No answers yet'}</TableCell>
              <TableCell className="tabular-nums">{reviewer ? reviewer.submitted : ''}</TableCell>
              <TableCell className="tabular-nums">{reviewer ? reviewer.inProgress : ''}</TableCell>
            </TableRow>
          ));
        })}
      </TableBody>
    </Table>
  );
}
